"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon toolbar-lock-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "28", height: "28", rx: "2.4", strokeWidth: "2" }),
            _react2.default.createElement("rect", { fill: "#4C4C4C", x: "8", y: "13", width: "12", height: "8", rx: ".711" }),
            _react2.default.createElement("path", { d: "M12 15.752c0 1.242.895 2.248 2 2.248 1.102 0 2-1.006 2-2.248v-4.504C16 10.006 15.105 9 14 9c-1.102 0-2 1.006-2 2.248v4.504zM10 11a4 4 0 0 1 8 0v4.808a4 4 0 0 1-8 0V11z", fill: "#4C4C4C", fillRule: "nonzero" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-lock-on.js
// module id = 1889
// module chunks = 0